export enum WorkType {
  'TIEANDSURFACE' = 'TS',
  'SURFACE' = 'SU',
  'RAIL' = 'RA',
  'SWITCHTIE' = 'XX'
}
